import React, { createContext, useContext, useState, useEffect } from 'react';

interface Settings {
  _id?: string;
  siteName: string;
  logo: string;
  favicon: string;
  // Add other settings fields as needed
}

interface SettingsContextType {
  settings: Settings;
  updateSettings: (newSettings: Partial<Settings>) => void;
}

const SettingsContext = createContext<SettingsContextType>({} as SettingsContextType);

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [settings, setSettings] = useState<Settings>({
    siteName: 'ERP',
    logo: 'https://encryptedinfoweb.com/uploads/1739016479_logo.png',
    favicon: 'https://media.licdn.com/dms/image/v2/D560BAQG31SitnvFjIA/company-logo_200_200/company-logo_200_200/0/1712129004074/encrypted_infoweb_logo?e=2147483647&v=beta&t=3bhMDUeO8Vc3ZFqI5HQFY16bIlrOYd7XIyHr2j6EG8M'
  });

  // Update document head when settings change
  useEffect(() => {
    updateDocumentHead(settings);
  }, [settings]);

  const updateSettings = (newSettings: Partial<Settings>) => {
    setSettings(prev => ({ ...prev, ...newSettings }));
  };

  return (
    <SettingsContext.Provider value={{ settings, updateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

const updateDocumentHead = (settings: Settings) => {
  // Update title
  document.title = settings.siteName || 'Default Site Name';

  // Update favicon
  let faviconElement = document.querySelector("link[rel*='icon']") as HTMLLinkElement | null;

  if (!faviconElement) {
    faviconElement = document.createElement('link') as HTMLLinkElement;
    faviconElement.rel = 'icon';
    document.head.appendChild(faviconElement);
  }

  faviconElement.href = settings.favicon || '/default-favicon.ico';
};

export const useSettings = () => useContext(SettingsContext);